// extracted by mini-css-extract-plugin
export default {"menuDotsSection":"style_menuDotsSection__Gre9q","dotsButton":"style_dotsButton__bDh9U","dot":"style_dot__EBqbM","dropdown":"style_dropdown__WNF4u"};